import { html } from 'lit';
import { Check } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-check')
export class PdsIconCheck extends PdsIcon {
  @state()
  icon = Check;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
